import { render, staticRenderFns } from "./createPassword.vue?vue&type=template&id=5dcbaec7&scoped=true"
import script from "./createPassword.vue?vue&type=script&lang=js"
export * from "./createPassword.vue?vue&type=script&lang=js"
import style0 from "./createPassword.vue?vue&type=style&index=0&id=5dcbaec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbaec7",
  null
  
)

export default component.exports